import Form from '../../common/form';
import Joi from 'joi';

import { func } from 'prop-types';

class UTInspectionItemForm extends Form {
	state = {
		data: {
			description: '',
			size: 0,
			nominal: '',
			a: '',
			twelveOC: '',
			threeOC: '',
			sixOC: '',
			nineOC: '',
			wtLoss: '',
			comments: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		description: Joi.string().min(3).required().label('Description'),
		size: Joi.number().min(1).required().label('Size (Inches)'),
		nominal: Joi.number().positive().required().label('Nominal'),
		a: Joi.string().required().label('A'),
		twelveOC: Joi.number().positive().required().label("12'O'c"),
		threeOC: Joi.number().positive().required().label("3'O'c"),
		sixOC: Joi.number().positive().required().label("6'O'c"),
		nineOC: Joi.number().positive().required().label("9'O'c"),
		wtLoss: Joi.number().positive().required().label('%WT.Loss'),
		comments: Joi.string().min(3).required().label('Comments'),
	};

	static propTypes = {
		onAdd: func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({
			data: {
				description: '',
				size: 0,
				nominal: '',
				a: '',
				twelveOC: '',
				threeOC: '',
				sixOC: '',
				nineOC: '',
				wtLoss: '',
				comments: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'size',
							label: 'Size (Inches)',
							placeholder: 'e.g. Inches',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							name: 'description',
							type: 'text',
							label: 'Description',
							placeholder: 'Enter Description',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'nominal',
							label: 'Nominal',
							placeholder: 'Enter Nominal',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'comments',
							label: 'Comments.',
							placeholder: 'Enter your comments here',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'a',
							label: 'A',
							placeholder: "Enter 'A' value",
						})}
					</div>
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'twelveOC',
							label: "12'O'c",
							placeholder: "Enter 12'O'c value",
						})}
					</div>
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'threeOC',
							label: "3'O'c",
							placeholder: "Enter 3'O'c value",
						})}
					</div>
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'sixOC',
							label: "6'O'c",
							placeholder: "Enter 6'O'c value",
						})}
					</div>
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'nineOC',
							label: "9'O'c",
							placeholder: "Enter 9'O'c value",
						})}
					</div>
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'wtLoss',
							label: '%WT.Loss',
							placeholder: 'Enter %WT.Loss value',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				{this.renderButton('Add Item')}
			</form>
		);
	}
}

export default UTInspectionItemForm;
